import OrderApi from "../../../api/modules/OrderApi";

const searchOrders = (_, payload) => {
  const {context, ...data} = payload;
  return OrderApi.searchOrders(context, data);
};

const downloadVaultOrderPdf = (_, payload) => {
  return OrderApi.downloadVaultOrderPdf(payload.context, payload.id);
};

const confirmOrder = (_, payload) => {
  return OrderApi.confirmOrder(payload.context, payload.idOrder, payload.request);
};

const exportOrdersExcel = (_, payload) => {
  return OrderApi.exportOrdersExcel(payload.context, payload.filters);
};

const exportOrdersPdf = (_, payload) => {
  return OrderApi.exportOrdersPdf(payload.context, payload.filters);
};

export default {
  searchOrders,
  downloadVaultOrderPdf,
  confirmOrder,
  exportOrdersExcel,
  exportOrdersPdf
};



// WEBPACK FOOTER //
// ./src/store/modules/order/actions.js